import React, { useEffect, useState } from 'react';
import { Table, Container, Alert, Button } from 'react-bootstrap'; // Importar componentes de Bootstrap
import { useNavigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';

function RankingPage() {
  const [ranking, setRanking] = useState([]);
  const [message, setMessage] = useState('');
  const [variant, setVariant] = useState('');
  const [btnLogin, setBtnLogin] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');  // Asumiendo que el token está en localStorage

    if (!token) {
      setMessage('Acceso denegado: No estás autenticado.');
      setVariant('danger');
      navigate('/login', { state: { from: '/ranking' } });
    }

    try {
        // Obtener el ranking desde el backend
        fetch('https://api.grekad.cfcunap.cl/api/ranking', {
          method: 'GET',
          headers: {
            Authorization: token,
          },
        })
          .then((response) => response.json())
          .then((data) => {
            if (data.success) {
              setRanking(data.ranking);
            } else {
              setMessage(data.message || 'Error al obtener el ranking.');
              setVariant('danger');
            }
          })
          .catch((error) => {
            setMessage('Error en la conexión al servidor.');
            setVariant('danger');
          });
    } catch (error) {
      setMessage('Token inválido. Por favor, vuelve a iniciar sesión.');
      setVariant('danger');
      //navigate('/login');
      navigate('/login', { state: { from: '/ranking' } });
    }
  }, [navigate]);


  return (
    <Container className="mt-2">
      <h2 className="titulo">Ranking de Votos</h2>
      {message && <Alert variant="danger">{message}</Alert>}

      {ranking.length > 0 ? (
        <Table striped bordered hover className="mt-3">
          <thead>
            <tr>
                <th>#</th>
                <th>Nombre</th>
                <th>Total de Votos</th>
            </tr>
          </thead>
          <tbody>
            {ranking.map((person,index) => (
              <tr key={person.nombre}>
                <td>{index + 1}</td>
                <td>{person.nombre}</td>
                <td>{person.total_votos}</td>
              </tr>
            ))}
          </tbody>
        </Table>
      ) : (
        <p>Cargando el ranking de votos...</p>
      )}
    </Container>
  );
}

export default RankingPage;
